import { cn } from "@/lib/utils";

export function Eyebrow({
  children,
  className,
  color = "gold",
}: {
  children: React.ReactNode;
  className?: string;
  color?: "gold" | "cream" | "red";
}) {
  const tones = {
    gold: "text-brand-gold",
    cream: "text-brand-cream",
    red: "text-brand-red",
  };
  return (
    <span
      className={cn(
        "font-italic-serif italic tracking-[0.18em] uppercase text-sm",
        tones[color],
        className
      )}
    >
      {children}
    </span>
  );
}
